import React, { useEffect, useState } from 'react'
import { Button, Grid, IconButton, Tooltip, Typography } from '@mui/material'
import { Add, Delete, InsertDriveFile } from '@mui/icons-material'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import { blue } from 'src/assets/colors'
import { useTranslate } from 'react-admin'

export const FilesCard = React.forwardRef(({ recordProduct }, ref) => {
  const translate = useTranslate()
  const [files, setFiles] = useState([])
  const [loadingFile, setLoadingFile] = useState(false)

  React.useImperativeHandle(ref, () => ({
    uploadPendingFiles
  }));

  useEffect(() => {
    ;(async () => {
      if (recordProduct) {
        const filesAux = await getFilesService(recordProduct.hash_)
        setFiles(filesAux || [])
      }
    })()
  }, [recordProduct]);

  const getFilesService = async (hash) => {
    try {
      const response = await reservationServices.getFiles(hash)
      return response
    } catch (error) {
      throw error
    }
  }

  const uploadFilesServices = async (files, productHash) => {
    const dataToSend = Array.from(files).map(file => {
      const formData = new FormData()
      formData.append('file_upload', file)
      formData.append('item_hash', productHash)
      return formData
    })

    try {
      setLoadingFile(true)
      const promises = dataToSend.map(async (elem) => {
        const response = await reservationServices.uploadFile(elem)
        return response;
      });

      const results = await Promise.all(promises);
      setLoadingFile(false)
      return results;
    } catch (error) {
      setLoadingFile(false)
      return [];
    }
  }

  const deleteFileService = async (id) => {
    try {
      const response = await reservationServices.deleteFile(id)
      return response
    } catch (error) {
      throw error
    }
  }

  const getFileName = (file) => {
    if (file.to_upload) {
      return file.name
    } else {
      return file.file_upload_detail.file_url.split('/').pop()
    }
  }

  const handleDownloadFile = (file) => {
    let url = ''
    if (file.to_upload) {
      url = URL.createObjectURL(file.file)
    } else {
      url = file.file_upload_detail.file_url
    }
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    if (file.to_upload) {
      URL.revokeObjectURL(url)
    }
  }

  const handleSelectFiles = async (selectedFiles) => {
    let newFiles = [];

    if (recordProduct) {
      const results = await uploadFilesServices(selectedFiles, recordProduct.hash_)
      newFiles = results.map(elem => elem.file_upload_by_item)
    } else {
      let count = 0;
      newFiles = Array.from(selectedFiles).map(elem => {
        const id = files.filter(file => file.to_upload).length + count
        count += 1
        return {
          id: `new_${id}`,
          to_upload: true,
          name: elem.name,
          file: elem
        }
      })
    }

    setFiles(current => [
      ...current,
      ...newFiles
    ])
  }

  const handleDeleteFile = async (event, file) => {
    event.stopPropagation()

    if (recordProduct) {
      await deleteFileService(file.id)
    }

    setFiles(current => current.filter(elem => elem.id !== file.id))
  }

  const uploadPendingFiles = async (productHash) => {
    const pendingFiles = files.filter(elem => elem.to_upload)
    if (pendingFiles.length > 0) {
      await uploadFilesServices(pendingFiles.map(elem => elem.file), productHash)
    }
  }

  return (
    <Grid container spacing={3} className='files-card'>
      <Grid item xs={12} className='files-container'>
        {files.map((elem, i) => (
          <div key={i} className='file' onClick={() => handleDownloadFile(elem)}>
            <InsertDriveFile color='primary' className='file-icon' />
            <Tooltip title={getFileName(elem)}>
              <Typography className='name'>{getFileName(elem)}</Typography>
            </Tooltip>
            <IconButton
              className='delete-icon'
              size='small'
              onClick={(e) => handleDeleteFile(e, elem)}
            >
              <Delete color='error' />
            </IconButton>
          </div>
        ))}
      </Grid>
      <Grid item xs={12}>
        <Button
          variant='standard'
          startIcon={<Add />}
          style={{ color: loadingFile ? '' : blue }}
          component="label"
          disabled={loadingFile}
        >
          {translate('ra.action.add_file')}
          <input
            type="file"
            hidden
            disabled={loadingFile}
            inputProps={{ multiple: true }}
            onClick={(e) => e.target.value = null}
            onChange={(e) => handleSelectFiles(e.target.files)}
          />
        </Button>
      </Grid>
    </Grid>
  )
})